import * as React from "react";
const FAQSVG = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3322_511880)">
      <path
        d="M13.99 1.01872C14.253 1.01899 14.5051 1.12357 14.691 1.30949C14.8769 1.49542 14.9815 1.7475 14.9817 2.01044V13.9906C14.9815 14.2535 14.8769 14.5056 14.691 14.6915C14.5051 14.8775 14.253 14.982 13.99 14.9823H2.01141C1.74852 14.9819 1.49651 14.8773 1.31061 14.6914C1.12471 14.5055 1.0201 14.2535 1.0197 13.9906V2.01044C1.01997 1.7475 1.12453 1.49542 1.31045 1.30949C1.49638 1.12357 1.74848 1.01899 2.01141 1.01872H13.9905M13.9905 0H2.01141C1.47821 0 0.966846 0.211823 0.589815 0.588854C0.212784 0.965885 0.000976562 1.47723 0.000976562 2.01044V13.9906C0.00124665 14.5236 0.21317 15.0347 0.590172 15.4115C0.967174 15.7883 1.47839 16 2.01141 16H13.9905C14.5237 16 15.0351 15.7882 15.4121 15.4112C15.7892 15.0341 16.001 14.5228 16.001 13.9896V2.01044C16.001 1.47723 15.7892 0.965885 15.4121 0.588854C15.0351 0.211823 14.5237 0 13.9905 0Z"
        fill="#888E9E"
      />
      <path
        d="M12.0877 6.5988H4.03426C3.89917 6.5988 3.76961 6.54513 3.67408 6.4496C3.57856 6.35408 3.5249 6.22453 3.5249 6.08944C3.5249 5.95435 3.57856 5.82478 3.67408 5.72926C3.76961 5.63373 3.89917 5.58008 4.03426 5.58008H12.0877C12.2228 5.58008 12.3524 5.63373 12.4479 5.72926C12.5434 5.82478 12.5971 5.95435 12.5971 6.08944C12.5971 6.22453 12.5434 6.35408 12.4479 6.4496C12.3524 6.54513 12.2228 6.5988 12.0877 6.5988Z"
        fill="#888E9E"
      />
      <path
        d="M12.0877 10.6261H4.03426C3.89917 10.6261 3.76961 10.5725 3.67408 10.4769C3.57856 10.3814 3.5249 10.2519 3.5249 10.1168C3.5249 9.98169 3.57856 9.85213 3.67408 9.7566C3.76961 9.66108 3.89917 9.60742 4.03426 9.60742H12.0877C12.2228 9.60742 12.3524 9.66108 12.4479 9.7566C12.5434 9.85213 12.5971 9.98169 12.5971 10.1168C12.5971 10.2519 12.5434 10.3814 12.4479 10.4769C12.3524 10.5725 12.2228 10.6261 12.0877 10.6261Z"
        fill="#888E9E"
      />
    </g>
    <defs>
      <clipPath id="clip0_3322_511880">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default FAQSVG;
